import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CaseService } from 'src/app/shared/services/case.service';
import { CorrespondenceTimelineService } from 'src/app/shared/services/correspondence-timeline.service';
import { KeyDatesService } from 'src/app/shared/services/keydates.service';
import { LookupsService } from 'src/app/shared/services/lookups.service';

@Component({
  selector: 'app-cancel-case',
  templateUrl: './cancel-case.component.html',
  styleUrls: ['./cancel-case.component.scss']
})
export class CancelCaseComponent implements OnInit {

  @Input() caseId: number = -1;

  public reasons?: any[];

  public selectedReason?: any;
  public cancellationReasonOther?: any = null;

  constructor(public activeModal: NgbActiveModal,
              private caseService: CaseService,
              private keyDatesService: KeyDatesService,
              private correspondenceTimelineService: CorrespondenceTimelineService,
              private lookupsService: LookupsService) {

    this.lookupsService.getCancellationReasons().subscribe((result : any) => {
      this.reasons = result;
    });
  }

  ngOnInit(): void {
  }

  cancel(){
    this.activeModal.dismiss();
  }

  save(){

    var reasonOther = null;

    if(this.selectedReason == 1)
      reasonOther = this.cancellationReasonOther

      var cancelDetails = {cancellationReasonId: this.selectedReason, cancellationReasonOther: reasonOther };

      this.caseService.cancelCase(this.caseId, cancelDetails).subscribe(response => {

        this.activeModal.close(true);
        this.correspondenceTimelineService.refreshCaseTimeline.next();
        this.keyDatesService.refreshKeyDates.next();
        this.caseService.refreshCase.next();

        }, error => {

          var errorMessage = "Failed to cancel case";
          if(error.error !== null && error.error.message !== undefined)
          {
            errorMessage = error.error.message;
          }

        });
  }

}
